import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import { guardArray } from "@msuite/utils/array";
import { client } from "@/hono";
import { useCitadel } from "@/hooks/use-citadel";

export function useVehicles() {
	/** Hooks */
	const { citadel } = useCitadel();

	/** Computed */
	// The route is gated on `read Vehicle`, and both surfaces that read the fleet — the vehicle list
	// and the planning board's resource panel — hide themselves from a caller without it. The query
	// has to agree, or the request still goes out behind the hidden surface and toasts a 403. Rules
	// still loading leave it enabled, so the server keeps the last word.
	const canRead = citadel ? citadel.can("read", "Vehicle") : true;

	/** Query */
	const query = useQuery({
		queryKey: ["vehicles"],
		queryFn: async () => {
			const response = await client.vehicles.index.$get();
			const data = await responseHandler(response);
			if (!data.vehicles) throw new Error("Failed to fetch vehicles");
			return data.vehicles;
		},
		enabled: canRead,
	});

	return {
		vehicles: guardArray(query.data),
		...query,
	};
}
